import * as d3 from 'd3'

const defaultStackedKeysLength = 1

const lightColor = d3.rgb('white')
const redColor = d3.rgb('#F68D7C')
const blueColor = d3.rgb('#6BC8E8')
const purpleColor = d3.rgb('#583D8B')
const yellowColor = d3.rgb('#FDD45C')
const turquoiseColor = d3.rgb('#75CBAE')
const navyBlueColor = d3.rgb('#17262D')

export let color

export function setupColor(stackedKeysLength) {
  const darkColorBank = [purpleColor, yellowColor, redColor, blueColor, turquoiseColor, navyBlueColor].slice(
    0,
    stackedKeysLength
  )
  const lightColorBank = Array(stackedKeysLength).fill(lightColor)
  const colorBank = darkColorBank.concat(lightColorBank)

  color = d3.scaleOrdinal(colorBank)
}

setupColor(defaultStackedKeysLength)
